import React, { useEffect, useState } from 'react'
import Navbar from './Navbar'
import FL1 from './bookIMG/frontline/FL1.jpg'
import white from './bookIMG/whitehouse/white_house.jpeg'
import we from './bookIMG/westend/we2.jpg'
import delisa from './bookIMG/delisa/delisa.jpg'
import frontline from './bookIMG/frontline/frontline.jpg'
import amen from './bookIMG/Amen/am1.jpg'
import ana from './bookIMG/Anarosa/An1.jpg'
import cana from './bookIMG/Canam/c1.jpeg'
import adom from './bookIMG/Adom bi/AB1.jpg'
import ban from './bookIMG/Banivallas/bn1.jpg'
import frank from './bookIMG/franko/fr2.jpg'
import gl from './bookIMG/Glory to god/gb1.jpeg'
import flint from './bookIMG/flint/flin1.jpg'
import morning from './bookIMG/morning star/ms1.jpg'
import man from './bookIMG/manchaster/ma1.png'
import sha from './bookIMG/shallom/sh1.jpeg'
import je from './bookIMG/jecado/jc1.jpg'
import happy from './bookIMG/happy_family/hf1.jpg'
import fplaza from './bookIMG/f-plaza/f1.jpg'
import fosua from './bookIMG/fosua home/f2.jpg'
import wag from './bookIMG/wagingo/wagingo.jpg'
import hal from './bookIMG/Hallowed/h1.jpg'
import no from './bookIMG/no weapon/nw1.jpg'
import p3 from './bookIMG/p3/p2.jpg'
import nyame from './bookIMG/nyameMeraku/nm4.jpg'
import st from './bookIMG/St Therisa/st1.jpg'
import ag from './bookIMG/asantewah g/ag1.jpg'
import knust from './bookIMG/knust_guest/knust g1.jpg'
import engineering from './bookIMG/engineering G/Engineering G1.jpg'
import abank from './bookIMG/Abank village Guest house/Abank village G1.jpg'
import ok from './bookIMG/ok guest/Okay g1.jpg'
import Bafffour from './bookIMG/Baffour Apartment/baffour.avif'
import osah from './bookIMG/Osaah Bema lodge/bloge.avif'
import Fredrick from "./bookIMG/Frederick's Lodge/fl1.1.avif"
import single from './bookIMG/SingleRoom Selfcontain/single.jpg'
import ran from './bookIMG/Renajoe .Ejusu/r1.avif'
import js from './bookIMG/JS/JS Way.avif'
import macoba from './bookIMG/Macoba Luxury Apartments/MB2.avif'
import './Home.css'
import { Link, useNavigate } from 'react-router-dom'
import Aos from 'aos'
import 'aos/dist/aos.css'
import { userContext } from '../App'
import { useContext } from 'react'
import ReactLoading from 'react-loading'
import './Loade.css'
import Explore from './Explore'
import anime from './Anime.json'
import Lottie from 'lottie-react'
import cat from './cat.json'
import ant from './Ant.json'
import my from './my.json'
const Home = () => {
  useEffect(()=>{
    Aos.init({duration:2000})
  },[])
  // list of hostels,Apartment and guest house in a json 
const [offcampus,setoffcampus]=useState([{
  name:'FRONTLINE',
  Price:'Ghc 3000 - Ghc 5500',
  type:'Hostel',
  location:'Ayeduasi',  
  image:FL1
},
{
  name:'WEST-END',
  Price:'Ghc 2800 - Ghc 5000',
  type:'Hostel',
  location:'Ayeduasi', 
  image:we
},
{
  name:'Asantewah GuestHouse',
  Price:'Ghc 300 -Ghc 2500',
  type:'Guesthouse',
  location:'Kumasi', 
  image:ag
},

{
  name:'Delisa',
  Price:'Ghc 3000 -Ghc 6000',
  type:'Hostel',
  location:'Kotei', 
  image:delisa
},
{
  name:'FRONTLINE Apartment',
  Price:'Ghc 3200 - Ghc 6000',
  type:'Apartment',
  location:'Ayeduasi', 
  image:frontline
},
{
  name:'White house',
  Price:'Ghc 3000 - Ghc 6000',
  type:'Hostel',
  location:'Ayeduasi', 
  image:white
},
{
  name:'Osah Bema Loge',
  Price:'Ghc 4700 - Ghc 10000',
  type:'Apartment',
  location:'Kumasi', 
  image:osah
},
{
  name:'KNUST GUESTHOUSE',
  Price:'Ghc 700 - Ghc 6000',
  type:'GuestHouse',
  location:'Osu', 
  image:knust
},

{
  name:'Amen',
  Price:'Ghc 3000 -Ghc 6000',
  type:'Hostel',
  location:'Ayeduasi', 
  image:amen
},
{
  name:'engineering Guesthouse',
  Price:'Ghc 800 -Ghc 7000',
  type:'Hostel',
  location:'College of Engineering (KNUSTCampus)', 
  image:engineering
},
{
  name:'Nyame Mireku ',
  Price:'Ghc 3000 - Ghc 6000',
  type:'Hostel',
  location:'Ayeduasi', 
  image:nyame
},
{
  name:'Anarosa',
  Price:'Ghc 3200 - Ghc5400',
  type:'Hostel',
  location:'Ayeduasi', 
  image:ana
},
{
  name:'Okay GuestHouse',
  Price:'Ghc 800 - Ghc 500',
  type:'GuestHoues',
  location:'Bomsu', 
  image:ok
},
{
  name:'Canam',
  Price:'Ghc 3000 - Ghc 6000',
  type:'Hostel',
  location:'Ayeduasi,Kotei', 
  image:cana
},
{
  name:'Baffour Apartment',
  Price:'Ghc 6000 - Ghc 10000',
  type:'Apartment',
  location:'Kumasi', 
  image:Bafffour
  },
{
  name:'No weapon',
  Price:'Ghc 3000 - Ghc 5500',
  type:'Hostel',
  location:'Ayeduasi,Kotei', 
  image:no
},
{
  name:'Adom Bi',
  Price:'Ghc 3000 - Ghc 6000',
  type:'Hostel',
  location:'Ayeduasi', 
  image:adom
},
{
  name:'Banivallas',
  Price:'Ghc 2300 - Ghc 4500',
  type:'Hostel',
  location:'Newsite', 
  image:ban
},
{
  name:'Franko',
  Price:'Ghc 3000 - Ghc 6000',
  type:'Hostel',
  location:'Ayeduasi', 
  image:frank
},
{
  name:'manchaster',
  Price:'Ghc 3000 -Ghc 5400',
  type:'Hostel',
  location:'Kotei', 
  image:man
},
{
  name:"Frederick's lodge",
  Price:'Ghc 37000 - Ghc 6000',
  type:'Apartment',
  location:'Kumasi', 
  image:Fredrick
  },
{
  name:'Abank vilage Guest house',
  Price:'Ghc 600 - Ghc 4000',
  type:'GuestHouse',
  location:'Bomsu', 
  image:abank
},
{
  name:'Glory to God',
  Price:'Ghc 2300 - Ghc4000',
  type:'Hostel',
  location:'Kotei', 
  image:gl
},
{
  name:'Flint',
  Price:'Ghc 3100 - Ghc 6000',
  type:'Hostel',
  location:'Ayeduasi', 
  image:flint
},
{
  name:'morning star',
  Price:'Ghc 2800 - Ghc 6000',
  type:'Hostel',
  location:'kotei', 
  image:morning
},
{
  name:'Shalom',
  Price:'Ghc 2300 - Ghc 55000',
  type:'Hostel',
  location:'Ayeduasi', 
  image:sha
},
{
  name:'Jecado',
  Price:'Ghc 3000 - Ghc 5000',
  type:'Hostel',
  location:'Ayeduasi', 
  image:je
},
{
  name:'happy family',
  Price:'Ghc 3300 - Ghc 6000',
  type:'Hostel',
  location:'Ayeduasi', 
  image:happy
},
{
  name:"Macoba Apartment",
  Price:'Ghc 6000 - Ghc 17000',
  type:'Apartment',
  location:'Kumasi', 
  image:macoba
  },
  {
    name:'Renajoe house',
    Price:'Ghc 600 - Ghc 2400',
    type:'Homestel',
    location:'Ejisu', 
    image:ran
  },
{
  name:'F Plaza',
  Price:'Ghc 3300 - Ghc 6300',
  type:'Hostel',
  location:'Ayeduasi,Kotei', 
  image:fplaza
},
{
  name:'Fosua home',
  Price:'Ghc 2400 - Ghc5000',
  type:'Hostel',
  location:'Kotei', 
  image:fosua
},
{
  name:'Wagingo',
  Price:'Ghc3400 - Ghc 6200',
  type:'Hostel',
  location:'Ayeduasi', 
  image:wag
},
{
  name:'1 bed room selfcontained',
  Price:'Ghc 1200 - Ghc 3000',
  type:'Homestel',
  location:'Ayeduasi', 
  image:single
},
{
  name:'Hallowed',
  Price:'Ghc 2400 -Ghc 4800',
  type:'Hostel',
  location:'Kotei', 
  image:hal
},
{
  name:'St theresa',
  Price:'Ghc 8000 - Ghc 17000',
  type:'Hostel',
  location:'Ayeduasi', 
  image:st
},
{
  name:'P3',
  Price:'Ghc 3000 - Ghc 6000',
  type:'Hostel',
  location:'Ayeduasi', 
  image:p3
},
{
name:'JS WAY',
Price:'Ghc 3900 - Ghc 7000',
type:'Apartment',
location:'TechJunction', 
image:js
}
])

const nav=useNavigate();
const [loading, setloading]=useState(true)
useEffect(()=>{
  setTimeout(() => {
    setloading(false)
  }, 2000);
})

const [search,hand,setsearch,location,setlocation,Locate,Kotei,Ayeduasi,Newsite,TechJunction,KNUSTCampus,Bomsu,Kumasi,price,setprice,main,price1,price2,price3,price4,price5,price6,price7,type,settype,types,Apartments,GuestHouse,homstel,Hostels,collapse,toggle,settoggle,toggler,arrow,setarrow, down,click,setclick,onpress]=useContext(userContext)

const map=offcampus.filter((list)=>{

})


  return ( 
    <div> 
     <Navbar />
      <div  className='grid lg:grid-cols-4 md:mt-3 md:mx-3 mx-5 sm:justify-center rounded-md gap-6 md:grid-cols-3 mt-[100px]' style={{paddingTop:'10%'}}>
    {
    offcampus.filter((post)=>{
      const name=post.name.toLocaleLowerCase();
      const find=search.toLocaleLowerCase(); 
      
      if(find==''){
        return post
      }
      if(name.startsWith(find)){
        return post
      }
    })
    .filter((post)=>{
        const look=location.toLocaleLowerCase();
        const loc=post.location.toLocaleLowerCase(); 
        if(look=='location'){
          return post
        }
        if(loc.includes(look)){
          return post
        }

    }).filter((post)=>{
      const cat=post.type.toLocaleLowerCase();
      const glory=type.toLocaleLowerCase();
      if(glory=='type'){
        return post
      }
      if(cat.includes(glory)){
        return post
      }
    }

    ).filter((post)=>{
      const pro=post.Price
      const pr=price;
      if(pr=='price'){
        return post
      }
      if(pro.includes(pro)){
        return post
      }
    }).length > 0? offcampus.filter((post)=>{
      const name=post.name.toLocaleLowerCase();
      const find=search.toLocaleLowerCase(); 
      
      if(find==''){
        return post
      }
      if(name.startsWith(find)){
        return post
      }
    })
    .filter((post)=>{
        const look=location.toLocaleLowerCase();
        const loc=post.location.toLocaleLowerCase(); 
        if(look=='location'){
          return post
        }
        if(loc.includes(look)){
          return post
        }

    }).filter((post)=>{
      const cat=post.type.toLocaleLowerCase();
      const glory=type.toLocaleLowerCase();
      if(glory=='type'){
        return post
      }
      if(cat.includes(glory)){
        return post
      }
    }

    ).filter((post)=>{
      const pro=post.Price
      const pr=price;
      if(pr=='price'){
        return post
      }
      if(pro.includes(pro)){
        return post
      }
    }
      
    ).map(post=><div className=' mx-auto' data-aos='fade-right'>
      <img className='rounded-lg shadow-md hover:-translate-y-5 cursor-pointer' style={{width:'400px',height:'300px'}}  src= {post.image} onClick={()=>{
        {
          if(post.image===FL1){
          nav('frontline');
        }
        if(post.image===we){
          nav('westend');
        }
        if(post.image===js){
          nav('js');
        }
        if(post.image===delisa){
          nav('delisa');
        }
        if(post.image==amen){
          nav('amen')
        }
        if(post.image===osah){
          nav('osah');
        }
        if(post.image==frontline){
          nav('fapartment')
        }
        if(post.image==knust){
          nav('knust')
        }
        if(post.image==ok){
          nav('okay')
        }
        if(post.image==ag){
          nav('yaa')
        }
        if(post.image==abank){
          nav('abank')
        }
        if(post.image==Bafffour){
          nav('baffour')
        }
        if(post.image==engineering){
          nav('engineering')
        }
        if(post.image==st){
          nav('therisa')
        }
        if(post.image==white){
          nav('whitehouse')
        }
        if(post.image==nyame){
          nav('nyame')
        }
        if(post.image==ana){
          nav('anarosa')
        }
        if(post.image==cana){
          nav('canam')
        }
        if(post.image==no){
          nav('noweapon')
        }
        if(post.image===ran){
          nav('ran');
        }
        if(post.image===single){
          nav('single');
        }
        if(post.image==adom){
          nav('adom')
        }
        if(post.image==ban){
          nav('banivallas')
        }
        if(post.image==frank){
          nav('franko')
        }
        if(post.image==man){
          nav('manchester')
        }
        if(post.image==gl){
          nav('glory')
        }
        if(post.image==flint){
          nav('flint')
        }
        if(post.image==morning){
          nav('morning')
        }
        if(post.image==sha){
          nav('shallom')
        }
        if(post.image==je){
          nav('jecado')
        }
        if(post.image==happy){
          nav('happy')
        }
        if(post.image==frontline){
          nav('fapartment')
        }
        if(post.image==fplaza){
          nav('fplaza')
        }
        if(post.image==fosua){
          nav('fosua')
        }
        if(post.image==wag){
          nav('wagingo')
        }
        if(post.image==hal){
          nav('hallowed')
        }
        if(post.image==Fredrick){
          nav('fredrick')
        }
        if(post.image==p3){
          nav('p3')
        }
        if(post.image==macoba){
          nav('macob')
        }
      }
      }} />
      <h2 className='font-bold from-neutral-950 font-serif uppercase' >{post.name} </h2>
      <div className='  text-gray-700 '>{post.type}</div>
      <div className=' text-red-700 '>{post.Price}</div>
      <div className=' text-gray-700 font-bold text-md'>{post.location}</div>
    </div>
    ):
    <div className=' bg-gray-200 md:w-[1620px] md:-mx-8 md:-mt-[60px] -mt-[60px] w-[412px] -mx-5'>
    <div className=' md:w-[400px] md:ml-[500px] '>
      <Lottie animationData={cat}/>
      </div>
      <h3 className=' md:text-3xl text-2xl font-bold font-serif md:ml-[440px] md:-mt-[47px] ml-4 -mt-14'>Sorry we couldn't find your search. </h3>
      </div>
      }
      </div>
    </div> 
  )
}

export default Home
